<template>
  <RouterLink
    v-slot="{ isActive, href, navigate }"
    custom
    :to="{ name: 'Connectors' }"
  >
    <a :href="href" class="MenuItemConnectors" @click="navigate">
      <TheSidebarMenuItem :isActive="isActive">
        <template #icon>
          <UIIcon class="MenuItemConnectors__icon" name="connector" />
        </template>
        <template #label>Connectors</template>
      </TheSidebarMenuItem>
    </a>
  </RouterLink>
</template>

<script setup lang="ts">
import { UIIcon } from '@foundever/ui-lib'

import TheSidebarMenuItem from '../TheSidebarMenuItem.vue'
</script>

<style scoped lang="scss">
.MenuItemConnectors {
  display: block;
  text-decoration: none;

  // The glyph is wide and flat; scaled, not resized, so the label stays aligned.
  .MenuItemConnectors__icon {
    transform: scale(1.2);
  }
}
</style>
